import { IUserAuthenticationState } from ".";
import * as actions from './actions'

const initialState: IUserAuthenticationState = {
    id: null,
    accessToken: null,
    expiresAt: null,
    //expiresIn: null,
    idToken: null
}
export const authenticationReducer = (state: IUserAuthenticationState = initialState, action) => {
    switch (action.type) {
        case actions.LOGIN_START:
        case actions.SIGN_UP_START:
        case actions.AUTHENTICATION_FAIL:
        case actions.LOGOUT:
            return initialState;
        case actions.AUTHENTICATION_SUCCESS:
        case actions.SIGN_UP_SUCCESS:
            return { ...state, ...action.payload }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/authentication/reducer.ts